export const GA_EVENTS = {
  clickToCall: 'lead_CLICK_TO_CALL',
  Purchase_bonifico: 'Purchase_bonifico',
  Purchase_finanziamento: 'Purchase_finanziamento',
  lead_SEARCH_AGGIORNAMENTI: 'lead_SEARCH_AGGIORNAMENTI',
  leadSelloutRegister: 'lead_PP_PROSEGUI',
  leadSelloutNoleggia: 'lead_NLT_PP_NOLEGGIA',
  leadSelloutPrenota: 'lead_PP_PRENOTA',
  Purchase_noleggio: 'Purchase_noleggio',
  REGISTER: 'REGISTER',
  VAS: 'VAS',
  PAYMENT_METHOD: 'PAYMENT_METHOD',
  PAYMENT_DATA: 'PAYMENT_DATA',
}

export const CRITEO_EVENTS = {
  BASKET_FUNNEL_SERVICES: 'funnel_services',
  BASKET_FUNNEL_CHECKOUT: 'funnel_checkout',
  BASKET_FUNNEL_PERSONAL_DATA: 'funnel_personal_data',
  BASKET_NLT_REGISTER: 'basket_registrazione_noleggio',
  GROSS_ORDER_NLT: 'nlt_gross_order',
  GROSS_ORDER_RETAIL: 'retail_gross_order',
  TRANSACTION: 'transaction',
}

export const EVENT_TYPES = {
  CRITEO: 'criteoEvent',
}

export const PRODUCT_TYPES = {
  REGISTER: 'register',
  VAS: 'vas',
  CHECKOUT: 'checkout',
  PAYMENT_DATA: 'payment_data',
}

export function triggerClickStreamEvent(name, type = 'event', payload = {}) {
  if (typeof window !== 'undefined') {
    const event = {
      name,
      type,
      ...payload,
    }
    try {
      window.clickstream.push(event)
    } catch (e) {
      // ignore
    }
  }
}

export default (name, type = 'event', payload = {}) => {
  if (typeof window !== 'undefined') {
    try {
      window.dataLayer.push({
        [type]: name,
        ...payload,
      })
    } catch (e) {
      // ignore
    }
  }
}
